var _style, _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.8534,
    y1: 255.9998,
    x2: 470.1466,
    y2: 255.9998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.2,9.9H76.8c-19.3,0-34.9,15.7-34.9,34.9v357.7c0,19.2,15.4,34.2,34.9,34.2h163.6 c18.5,27.5,44.2,49.8,74.8,64.7c1,0.5,2.1,0.8,3.3,0.8c1.1,0,2.2-0.3,3.3-0.8c30.5-14.9,56.3-37.3,74.7-64.7h38.7 c19.3,0,34.9-15.7,34.9-34.9V44.8C470.1,25.9,454.1,9.9,435.2,9.9z M76.8,24.8h358.4c10.7,0,20.1,9.4,20.1,20.1v34.9H56.7V44.8 C56.7,33.8,65.7,24.8,76.8,24.8z M318.5,486.4c-27.6-14.2-50.9-35-67.4-60.4c-0.3-0.4-0.8-1.2-1.2-1.6c-0.4-0.6-0.8-1.2-1.3-1.8 c-17.6-28.7-26.9-60.9-26.9-93v-58.5l95.9-46.2l96.6,46.3v58.5c0,35-9.9,68.3-28.5,96.3C369.4,451.4,346.1,472.2,318.5,486.4z  M435.2,421.8h-29.5c15.4-27.7,23.5-59.2,23.5-92.2v-63.2c0-2.9-1.6-5.5-4.2-6.7l-104.1-49.8c-2-1-4.4-1-6.4,0l-103.4,49.8 c-2.6,1.2-4.2,3.8-4.2,6.7v63.2c0,31.7,8.4,63.3,24.2,92.2H76.8c-11.3,0-20.1-8.5-20.1-19.3V94.6h398.6v307.1 C455.3,412.8,446.3,421.8,435.2,421.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.1496,
    y1: 53.7492,
    x2: 426.2803,
    y2: 53.7492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 412.1,
    y: 46.3,
    className: "st1",
    width: 14.1,
    height: 14.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.9711,
    y1: 53.7492,
    x2: 388.3539,
    y2: 53.7492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 46.3,
    className: "st2",
    width: 13.4,
    height: 14.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.7927,
    y1: 53.7492,
    x2: 351.1754,
    y2: 53.7492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 337.8,
    y: 46.3,
    className: "st3",
    width: 13.4,
    height: 14.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.979,
    y1: 53.7492,
    x2: 296.8963,
    y2: 53.7492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 46.3,
    className: "st4",
    width: 211.9,
    height: 14.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.6172,
    y1: 354.8958,
    x2: 391.3311,
    y2: 354.8958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M387.1,283.5l-66.9-32c-2-1-4.4-1-6.4,0l-66.9,32c-2.6,1.2-4.2,3.8-4.2,6.7v40.2c0,38.2,15.1,76.1,41.4,104 l5.4-5.1l-5.3,5.3c9.1,9.1,18.5,16.7,28.8,23.3c1.2,0.8,2.6,1.2,4,1.2c1.3,0,2.5-0.3,3.7-1c11.5-6.6,21.1-15.6,29.1-23.5l-5.3-5.3 l5.3,5.2c26.4-27.2,41.5-65.1,41.5-104.1v-40.2C391.3,287.3,389.7,284.7,387.1,283.5z M376.5,330.4c0,35.1-13.6,69.3-37.3,93.7 c-6.3,6.3-13.7,13.2-22,18.7c-7.9-5.4-15.2-11.5-22.3-18.7c-23.7-25.2-37.3-59.3-37.3-93.7v-35.5l59.5-28.4l59.5,28.4V330.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.4855,
    y1: 347.7859,
    x2: 354.9006,
    y2: 347.7859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M291,345.2l-10.5,10.5l18.6,18.6c1.5,1.5,3.4,2.2,5.3,2.2c1.9,0,3.8-0.7,5.2-2.1l45.4-44.6l-10.4-10.6 l-40.1,39.4L291,345.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.5433,
    y1: 153.7608,
    x2: 253.7707,
    y2: 153.7608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M246.3,117.7H85c-4.1,0-7.4,3.3-7.4,7.4v57.3c0,4.1,3.3,7.4,7.4,7.4h161.4c4.1,0,7.4-3.3,7.4-7.4v-57.3 C253.8,121,250.4,117.7,246.3,117.7z M238.9,175H92.4v-42.4h146.5V175z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.5433,
    y1: 214.3609,
    x2: 218.0772,
    y2: 214.3609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 206.9,
    className: "st8",
    width: 140.5,
    height: 14.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.5433,
    y1: 245.5923,
    x2: 166.0274,
    y2: 245.5923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 238.2,
    className: "st9",
    width: 88.5,
    height: 14.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeystore);
export default __webpack_public_path__ + "static/media/keystore.bf086190b351d580e4dc65b395918519.svg";
export { ForwardRef as ReactComponent };